export default __webpack_public_path__ + "images/kpPassportLogo.v-e01303d0581d6f0e5911467f0150b361.png";